( function ( root, factory ) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
			'message-service/message-service'
              ], factory );
    } else if ( typeof exports === 'object' ) {
        // Node, CommonJS-like
        module.exports = factory(
            require( 'message-service/message-service' )
        );
    } else {
        // Browser globals (root is window)
        root.Bandwagon = factory(root.MessageService);
    }
} )( this, function ( MessageService ) {
    'use strict';

    var the_bandwagon, //bandwagon instance
    	eventsCache = {
	    	global: {}
	    }, //events subscribed to
    	messageServiceCache = {}; //messageService instances spun up;

    /**
     *  Constructor
     */
    function Bandwagon () {
	    //console.log("bandwagon constructor")
		init();
    }

    var init = function() {
	   //console.log("bandwagon init");
    }

    Bandwagon.prototype = {
        /**
	     *  Register events enum with bandwagon
	     *  @param {string} ns - namespace to store events enum in object. If not provided, will dump in "global".
	     *	@param {object} events - events enum object to store
	     */
	    registerEvents: function ( ns, events ) {

			if (!ns) {
    			//console.log("bandwagon: extend global events enum : ", events )
				this.merge( events, ns );
			} else {
    			if (eventsCache[ns]) {
        			//console.log("bandwagon: extend existing events enum :" + ns, events)
                    this.merge( events, ns );
                } else {
                    //console.log("bandwagon: adding events enum: " + ns, events)
                    eventsCache[ns] = events;
                }
			}

			return;
	    },

        /**
        *
        * Merge custom events into global event object
        * if a namespace exists will merge new properties into that namespace
        * @param {object} events
        */
        merge: function ( events, ns ) {

            for (var e in events) {
                if (events.hasOwnProperty(e)) {
                    eventsCache[ns ? ns : 'global'][e] = events[e];
                }
            }

        },

	    /**
	     *  Delete events enum from bandwagon
	     *  @param {string} key - namespace to delete from cache
	     */
	    deleteEventsByKey: function ( key ) {
		    //console.log("bandwagon: deleting events enum: " + key);

            if (key && eventsCache[key]) {

            	delete eventsCache[key];

            } else {

                console.log("bandwagon: specified namespace does not exist in events cache to delete", key)

            }

		    return;
	    },

	    /**
	     *  Return events enum from bandwagon
	     */
	    getRegisteredEvents: function () {

			return eventsCache;

	    },

	    /**
	     *  Return events enum from bandwagon by key
	     *  @param {string} key - namespace to return from object
	     */
	    getRegisteredEventsByKey: function ( key ) {

		  	var events;

		  	if ( key && eventsCache[key] ) {
				events = eventsCache[key]
		  	} else {
				console.log("please provide valid event key you want to retrieve from the events cache", key);
		  	}

		  	return events;

	    },

		/**
	     *  Return instance of Message service by key. If instance does not exist, it will be created.
	     *	@param {string} key - message service is stored by this key
	     */
	    getInstanceByKey: function ( key ) {

    	    var instance = {};

            if (key && !messageServiceCache[key]) {
                //console.log("bandwagon: new messageService instance -> " + key)
                instance = messageServiceCache[key] = MessageService.create();
            } else {
                //console.log("bandwagon: existing messageService instance -> " + key)
                instance = messageServiceCache[key];
            }

            //console.log("messageServiceInstance returned by key: " + key, instance)

            return instance;
	    },

	    /**
	     *  Returns cache object of instances
	     */
	    getInstancesAvailable: function () {

            //console.log("bandwagon: stored messageService instances", messageServiceCache)

            return messageServiceCache;

	    },

	    /**
	     *  Delete instance of message service by key
	     *  @param {string} key - instance to delete out of cache
	     */
	    deleteInstanceByKey: function (key) {

    	    //console.log("bandwagon: delete messageService instance -> " + key )

    	    if (key && messageServiceCache[key]) {

    	        delete messageServiceCache[key];

    	    } else {

        	    console.log("bandwagon: specified key does not exist in cache to delete", key)

    	    }

    	    return;

	    }

	}

    // return Bandwagon instance.
    return (the_bandwagon = (the_bandwagon || new Bandwagon()));
} );
